import { render, staticRenderFns } from "./HangGlidingQuestionnaire.vue?vue&type=template&id=b2d27314"
import script from "./HangGlidingQuestionnaire.vue?vue&type=script&lang=js"
export * from "./HangGlidingQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports